export default __webpack_public_path__ + "static/media/Avengers.4065c8f9.png";